module.exports = __webpack_public_path__ + "img/suzhou.a3c2294d.png";